<template>
    <div class="td-container fluid" id="dashboard">
        <status-message></status-message>

        <div class="dashboard-container">

            <div v-if="showNoLocations && showNoLocations === true" class="td-card fluid rounded">
                <div class="item heading">
                    <h3>
                        No advertised listings found on account.
                    </h3>
                    <p>
                        Promotions are only available for advertised listings.
                    </p>
                    <p>
                        Please add or update a listing with one of our advertising options.  For more information on our advertising services, <a href="/shop/advertise">click here</a>.
                    </p>
                    <p>
                        <a class="td-btn primary icon-left mt-5" title="View Listings" href="/listings">
                            View Listings
                        </a>
                    </p>
                </div>
            </div>

            <div v-if="!showNoLocations" class="dashboard-details td-card fluid rounded">
                <div v-if="!isLoading && enableEdit" class="item heading">
                    <button class="td-btn primary icon-left" title="Add Promotion" @click="toggleAddPromotionModal">
                        <icon name="faPlus" type="solid"></icon> Add Promotion
                    </button>
                </div>

                <div v-if="isLoading" class="loading_container">
                    <icon type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                </div>

                <div class="item heading td-text-bold" v-if="!isLoading && showNoPromotions && showNoPromotions === true">
                    <p>
                        No promotions found.  Click Add Promotion to create a new promotion.
                    </p>
                </div>

                <div v-if="!isLoading && listings.length > 0">
                    <div v-for="promotion in promotions" :key="promotion.id">
                        <promotion-summary :taxname="taxname" :taxrate="taxrate" :promotion="promotion" :listing="getListing(promotion, listings)" @removed="removePromo" @updated="updatePromo"></promotion-summary>
                    </div>
                </div>

                <div v-if="showAddPromotion">
                    <add-promotion :accountid="accountId" @cancel="cancelAdd" @promotion-update="applyAdd"></add-promotion>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import script from './Dashboard';
    export default script;
</script>

<style lang="less">
    @import './Dashboard.less';
</style>